import React, { useState } from "react";
import { useHasPermission } from "hooks/useHasPermission";
import CreateRoleModal from "./CreateRoleModal";

function RoleForm() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const canView = useHasPermission("Role-view");
  const canEdit = useHasPermission("Role-manage");

  if(!canView) return <p className='perm-msg'>You don't have permission to view roles!</p>;

  return (
    <>
      <div className="user-role-create">
        <div className="user-role-form">
          <button 
            type="button" 
            className="primary-btn pl-5 pr-5"
            title={canEdit ? "add role" : "No permission to add role"}
            onClick={() => canEdit && setShowCreateModal(true)}
            disabled={!canEdit}
          >
            <i className="fe fe-plus"></i> Add Role
          </button>
        </div>
      </div>

      <CreateRoleModal 
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        canEdit={canEdit}
      />
    </>
  );
}

export default RoleForm;
